// IMPORTANTE: No commitear cambios en este archivo al repositorio
// Para modificar este archivo localmente, hay que ejecutar primero 'vibia localtoggles true'
// Más información: https://vibia.atlassian.net/wiki/spaces/QA/pages/2181824513/Toggles

const TogglesLocal = {
    disableSendOrderToAS400ForQAUser: 0
}

export default TogglesLocal
